import { render, staticRenderFns } from "./FiltroCategoria.vue?vue&type=template&id=74830a67&scoped=true"
import script from "./FiltroCategoria.vue?vue&type=script&lang=js"
export * from "./FiltroCategoria.vue?vue&type=script&lang=js"
import style0 from "./FiltroCategoria.vue?vue&type=style&index=0&id=74830a67&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74830a67",
  null
  
)

export default component.exports